<div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <div>
        <div style="line-height: 20px;">
            <button mat-raised-button [color]="filterValue==='all'? 'primary': 'accent'" (click)="filterPostItems('all')">
                <span>{{'All'|translate}}</span>
            </button>
            &nbsp;
            <button mat-raised-button [color]="filterValue==='products'? 'primary': 'accent'" (click)="filterPostItems('products')">
                <span>{{'Products'|translate}}</span>
            </button>
            &nbsp;
            <button mat-raised-button [color]="filterValue==='vouchers'? 'primary': 'accent'" (click)="filterPostItems('vouchers')">
                <span>{{'Vouchers'|translate}}</span>
            </button>
            &nbsp;
            <button mat-raised-button color="accent" *ngFor="let category of categories">
                <span>{{category.name}}</span>
            </button>
            &nbsp;
            <button mat-raised-button (click)="showDiscountsDialog()">
                <span>{{'Active discounts'|translate}}</span>
            </button>
            &nbsp;
            <button mat-raised-button color="accet" routerLink="/open-bills" [routerLinkActive]="[]">
                <span>{{'Open bills'|translate}}</span>
            </button>
        </div>
        <!-- Voucher Groups Filter -->
        <div style="line-height: 20px; margin-top: 12px;" *ngIf="voucherGroups.length > 0">
            <button mat-stroked-button
                    [color]="selectedVoucherGroupId === null ? 'primary' : ''"
                    (click)="filterPostItemsByVoucherGroup(null)">
                <span>{{'All Vouchers'|translate}}</span>
            </button>
            &nbsp;
            <button mat-stroked-button
                    *ngFor="let group of voucherGroups"
                    [color]="selectedVoucherGroupId === group.id ? 'primary' : ''"
                    [style.border-color]="group.color"
                    [style.color]="selectedVoucherGroupId === group.id ? '' : group.color"
                    (click)="filterPostItemsByVoucherGroup(group.id)">
                <span>{{group.name}}</span>
            </button>
        </div>
    </div>
</div>
